<form [formGroup]="formdata">
  <div class="row row-cols-1 row cols-lg-2 pb-5">
    @if (currentStep !== 2) {
      <div
        class="col col-lg-6 p-3 p-lg-4 rounded bg-white border border-3 text-dark mb-3 mb-lg-0"
        [class.mobile-brief-section]="!largeView"
      >
        <div class="row gap-4">
          @if (selectedJobType?.id) {
            <div>
              <dl class="m-0">
                <dt>Job Type</dt>
                <dd class="fw-semibold">{{ selectedJobType?.name }}</dd>
              </dl>
            </div>
          }
          @if (formdata.value?.name) {
            <div (click)="currentStep = 1; shiftFocus('mobnameField')">
              <dl class="m-0" role="button">
                <dt>Patrol Name</dt>
                <dd class="d-flex gap-2 align-items-center">
                  {{ formdata.value?.name }}
                </dd>
              </dl>
            </div>
          }
          @if (patrolJobType?.checkpoints?.data?.length) {
            <div (click)="currentStep = 2">
              <dl class="m-0" role="button">
                <dt>
                  Checkpoints [{{ patrolJobType?.checkpoints?.data?.length }}]
                  @if (patrolJobType?.checkpoints?.data?.length > 5) {
                    <span
                      >(+
                      {{ patrolJobType?.checkpoints?.data?.length - 5 }}
                      more)</span
                    >
                  }
                </dt>
                <dd>
                  @for (
                    checkpoint of patrolJobType?.checkpoints?.data?.slice(0, 5);
                    track checkpoint
                  ) {
                    <div
                      class="border mb-2 p-2 bg-secondary-subtle text-dark d-flex gap-2"
                    >
                      <div>
                        <i class="fa-solid fa-location-dot"></i>
                      </div>
                      <div>
                        {{ checkpoint?.name }}
                        <div class="small">
                          @if (checkpoint?.site_name) {
                            {{ checkpoint?.site_name }} [{{
                              checkpoint?.company || checkpoint?.company_name
                            }}]
                          } @else {
                            {{
                              checkpoint?.company || checkpoint?.company_name
                            }}
                          }
                        </div>
                        <div class="small">
                          {{ checkpoint?.full_address }}
                        </div>
                      </div>
                      @if (checkpoint?.qr_code) {
                        <div class="ms-auto">
                          @if (checkpoint?.is_nfc_code) {
                            <img
                              src="assets/images/NFC_logo.avif"
                              alt="NFC Code"
                              width="36"
                              class="mb-0 bg-white p-1 rounded"
                            />
                          } @else {
                            <img
                              src="assets/images/qr-code-logo.avif"
                              alt="QR Code"
                              width="36"
                              class="mb-0 bg-white p-1 rounded"
                            />
                          }
                        </div>
                      }
                    </div>
                  }
                </dd>
              </dl>
            </div>
          }
          @if (formdata.value?.patrol_brief) {
            <div>
              <dl
                class="m-0"
                (click)="currentStep = 3; shiftFocus('patrolBriefField')"
                role="button"
              >
                <dt>Patrol Information</dt>
                <dd>{{ formdata.value?.patrol_brief }}</dd>
              </dl>
            </div>
          }
          @if (assignedGuardData?.id) {
            <div>
              <dl
                class="m-0"
                (click)="
                  currentStep = 4;
                  assigneeList = [];
                  getAssignees();
                  shiftFocus('assigneeId')
                "
                role="button"
              >
                <dt>Assign To</dt>
                <dd>
                  <span
                    [gtappPopover]="userDetailPopoverTemplate"
                    [popoverData]="{ userId: assignedGuardData?.id }"
                  >
                    {{ assignedGuardData?.full_name }}
                  </span>
                </dd>
              </dl>
            </div>
          }
        </div>
      </div>
    }
    <div [ngClass]="currentStep === 2 ? 'col-12' : 'col col-lg-6 px-lg-2'">
      @if (currentStep === 1) {
        <div class="row mb-2">
          <div class="form-floating">
            <input
              autofocus
              id="mobnameField"
              class="form-control"
              type="text"
              placeholder="Name"
              autocomplete="off"
              formControlName="name"
            />
            <label for="mobnameField">Name</label>
          </div>
        </div>
        <div class="row row-cols-2 g-2 mb-4">
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-secondary w-100"
              (click)="goBack()"
            >
              Cancel
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-primary w-100"
              [disabled]="!formdata.value?.name"
              (click)="getPatrolRouteCheckpoints(); currentStep = 2"
            >
              Next
            </button>
          </div>
        </div>
        @if (patrolRouteSuggestionsDataList?.length) {
          <div class="border border-1 rounded p-2">
            <div class="fw-semibold small mb-2">Preload Previous Patrol</div>
            <div class="d-flex flex-wrap gap-2">
              @for (route of patrolRouteSuggestionsDataList; track route) {
                <div (click)="selectSuggestedRoute(route)">
                  <div
                    class="bg-secondary-subtle p-2 border rounded small-font text-dark"
                    [title]="route?.checkpoints"
                    role="button"
                  >
                    <div class="d-flex gap-3">
                      <div class="flex-grow-1 fw-semibold">
                        {{ route?.name }}
                      </div>
                      <div>
                        <i class="fa-solid fa-location-dot"></i>
                        {{ route?.checkpoints?.length }}
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      }
      @if (currentStep === 2) {
        @if (largeView) {
          <div class="row row-cols-3">
            <div class="col">
              <ng-template
                *ngTemplateOutlet="
                  checkPointSearchSelectTemplate;
                  context: { value: { search: true } }
                "
              ></ng-template>
            </div>
            <div class="col">
              <ng-template
                *ngTemplateOutlet="checkPointSearchSelectTemplate; context: {}"
              ></ng-template>
            </div>
            <div class="col">
              @if (selectedLastCP?.latitude) {
                <gtapp-map-leaflet
                  [latLon]="{
                    lat: selectedLastCP.latitude,
                    lon: selectedLastCP.longitude,
                  }"
                  [mapId]="'largeJob'"
                ></gtapp-map-leaflet>
              }
            </div>
            <div class="row row-cols-2 g-2">
              <div class="col">
                <button
                  type="button"
                  class="btn btn-lg btn-secondary w-100"
                  (click)="
                    patrolRouteCPList = []; currentStep = 1; patrolCPCursor = ''
                  "
                >
                  Back
                </button>
              </div>
              <div class="col">
                <button
                  type="button"
                  class="btn btn-lg btn-primary w-100"
                  [disabled]="!patrolJobType?.checkpoints?.data?.length"
                  (click)="currentStep = 3; shiftFocus('patrolBriefField')"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        }
        @if (!largeView) {
          <div class="row row-cols-2 g-2 mb-3">
            <div class="col">
              <button
                type="button"
                class="btn btn-lg btn-secondary w-100"
                (click)="
                  patrolRouteCPList = []; currentStep = 1; patrolCPCursor = ''
                "
              >
                Back
              </button>
            </div>
            <div class="col">
              <button
                type="button"
                class="btn btn-lg btn-primary w-100"
                [disabled]="!patrolJobType?.checkpoints?.data?.length"
                (click)="currentStep = 3; shiftFocus('patrolBriefField')"
              >
                Next
              </button>
            </div>
          </div>
          <div>
            <!-- Tabs Navigation for mobile view-->
            <ul class="nav nav-tabs" id="checkpointsTab" role="tablist">
              <li class="nav-item" role="presentation">
                <a
                  class="nav-link active"
                  id="all-checkpoints-tab"
                  data-bs-toggle="tab"
                  href="#all-checkpoints"
                  role="tab"
                  aria-controls="all-checkpoints"
                  aria-selected="true"
                  >Checkpoints</a
                >
              </li>
              @if (patrolJobType?.checkpoints?.data?.length > 0) {
                <li class="nav-item" role="presentation">
                  <a
                    class="nav-link"
                    id="selected-checkpoints-tab"
                    data-bs-toggle="tab"
                    href="#selected-checkpoints"
                    role="tab"
                    aria-controls="selected-checkpoints"
                    aria-selected="false"
                    >Added
                    <span class="badge bg-primary ms-1 fw-normal">{{
                      patrolJobType?.checkpoints?.data?.length
                    }}</span>
                  </a>
                </li>
              }
            </ul>
            <!-- Tabs Content -->
            <div class="tab-content" id="checkpointsTabContent">
              <!-- All Checkpoints Tab -->
              <div
                class="tab-pane fade show active"
                id="all-checkpoints"
                role="tabpanel"
                aria-labelledby="all-checkpoints-tab"
              >
                <ng-template
                  *ngTemplateOutlet="
                    checkPointSearchSelectTemplate;
                    context: { value: { search: true } }
                  "
                ></ng-template>
              </div>
              <!-- Selected Checkpoints Tab -->
              <div
                class="tab-pane fade"
                id="selected-checkpoints"
                role="tabpanel"
                aria-labelledby="selected-checkpoints-tab"
              >
                <ng-template
                  *ngTemplateOutlet="
                    checkPointSearchSelectTemplate;
                    context: {}
                  "
                ></ng-template>
              </div>
            </div>
          </div>
        }
      }
      @if (currentStep === 3) {
        <div class="row row-cols-2 g-2 mb-3">
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-secondary w-100"
              (click)="currentStep = 2"
            >
              Back
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-primary w-100"
              (click)="
                currentStep = 4;
                assigneeList = [];
                getAssignees();
                shiftFocus('assigneeId')
              "
            >
              Next
            </button>
          </div>
        </div>
        <div class="mb-2">
          <textarea
            class="form-control"
            cols="20"
            rows="10"
            wrap="hard"
            maxlength="900"
            type="text"
            formControlName="patrol_brief"
            placeholder="Patrol Information (Optional)"
            id="patrolBriefField"
          ></textarea>
        </div>
        <div class="d-flex mb-2">
          @if (patrolJobType.patrol_brief_files.value) {
            <div
              class="d-flex align-items-center justify-content-between w-100"
            >
              <div class="flex-grow-1 fw-bold text-truncate pe-2">
                {{ patrolJobType.patrol_brief_files.value?.name }}
              </div>
              <div>
                <button
                  type="button"
                  class="btn btn-md btn-secondary"
                  (click)="patrolJobType.patrol_brief_files.value = null"
                >
                  Remove File
                </button>
              </div>
            </div>
          }
          @if (!patrolJobType.patrol_brief_files.value) {
            <div class="w-100">
              <button
                type="button"
                class="btn btn-md btn-secondary w-100 btn-lg"
                (click)="uploadFile()"
              >
                Upload File
              </button>
              <input
                #fileInput
                id="fileInput"
                style="display: none; cursor: pointer"
                type="file"
                accept="application/pdf, .jpg, .jpeg, .png, .webp, .avif"
                (change)="handleFileInput($event)"
              />
            </div>
          }
        </div>
      }
      @if (currentStep === 4) {
        <div class="row row-cols-2 mb-2">
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-secondary w-100"
              (click)="
                currentStep = 3;
                assigneeList = [];
                shiftFocus('patrolBriefField')
              "
            >
              Back
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-primary w-100"
              (click)="formatScheduleForm(); currentStep = 5"
            >
              Next
            </button>
          </div>
        </div>
        <div class="mb-2">Assign Patrol To</div>
        @if (assignedGuardData?.id) {
          <dl>
            <dd (click)="editField('assignee')" class="link-edit">
              {{ assignedGuardData?.full_name }}
            </dd>
          </dl>
        } @else {
          <gtapp-auto-complete
            [data]="assigneeList"
            placeHolder="Assign To"
            searchKeyword="full_name"
            [itemTemplate]="assigneeTemplate"
            (inputChanged)="onAssigneeSearch($event)"
            (selected)="onAssigneeSelect($event)"
            [enableCloseOption]="true"
            (fieldCleared)="editField('assignee')"
            [inputId]="'assigneeId'"
          >
          </gtapp-auto-complete>
          <ng-template #assigneeTemplate let-item>
            <div class="d-flex gap-2 flex-wrap">
              <span>
                {{ item?.full_name }}
              </span>
              @if (item?.access_status === 2) {
                <div
                  class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
                >
                  Casual
                </div>
              }
            </div>
            @if (item?.subcontractors?.length) {
              <div class="small text-secondary">
                🟧Subcontractor:
                <span class="subcontractor-name">{{
                  item?.subcontractors
                }}</span>
              </div>
            }
          </ng-template>
        }
      }
      @if (currentStep === 5) {
        <div class="row row-cols-2 mb-2">
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-secondary w-100"
              (click)="currentStep = 4; saveCurrentSchedule()"
            >
              Back
            </button>
          </div>
          <div class="col">
            <button
              type="button"
              class="btn btn-lg btn-primary w-100"
              (click)="onAddJob()"
              [disabled]="
                !patrolJobType.checkpoints?.data?.length ||
                addJobPressed ||
                !schedulerForm.valid
              "
            >
              Add Job
            </button>
          </div>
        </div>
        <div class="mb-2">
          @if (scheduleStepperActive) {
            <gtapp-scheduler
              [dialogBox]="false"
              [schedulerForm]="schedulerForm"
              [editSchedule]="true"
            ></gtapp-scheduler>
          }
        </div>
        <div class="form-floating">
          <select
            class="form-select"
            (click)="getIntervalData()"
            [ngModel]="intervalCheck"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="updateInterval($event)"
            placeholder="Welfare Check Interval"
          >
            @for (interval of intervalData; track interval) {
              <option [ngValue]="interval.value">
                {{ interval.name }}
              </option>
            }
          </select>
          <label for="">Welfare Check Interval</label>
        </div>
        @if (intervalCheck) {
          <div class="alert">
            <div class="mb-2">
              Guards will be reminded to submit a welfare check
              <span class="fw-bold">
                {{ welfareReminderDict?.[intervalCheck] }} minutes before</span
              >
              the interval set above.
            </div>
            <div>
              Maximum inactivity time allowed before a missed welfare check is
              recorded:
              <span class="fst-italic fw-bold">
                {{ intervalCheck }} minutes.
              </span>
            </div>
          </div>
        }
      }
    </div>
  </div>
</form>

<!-- checkpoint search/selection code to avoid code duplcation -->
<ng-template let-dataItem="value" #checkPointSearchSelectTemplate>
  @if (dataItem?.search) {
    @if (patrolRouteCpTotalCount > 10) {
      @if (cpSiteFilter?.id) {
        <dl>
          <dd
            (click)="
              cpSiteFilter = {};
              inputFieldFocused();
              shiftFocus('siteId');
              getPatrolRouteCheckpoints()
            "
            class="link-edit"
          >
            {{ cpSiteFilter?.company_name }}
            @if (cpSiteFilter?.company?.company_name) {
              <span> [{{ cpSiteFilter?.company?.company_name }}] </span>
            }
          </dd>
        </dl>
      } @else {
        <gtapp-auto-complete
          [data]="siteListData"
          placeHolder="Filter by Site"
          searchKeyword="company_name"
          [itemTemplate]="siteTemplate"
          (inputChanged)="onSiteSearch($event)"
          (selected)="onSelectSite($event)"
          inputId="siteId"
          [enableCloseOption]="true"
          (inputFocused)="inputFieldFocused()"
        >
        </gtapp-auto-complete>
        <ng-template #siteTemplate let-item>
          <div>
            <div class="fw-medium">
              {{ item?.company_name }} [{{ item?.company?.company_name }}]
            </div>

            <div class="small-font text-secondary">
              {{ item?.address?.full_address }}
            </div>
          </div>
        </ng-template>
      }
      @if (patrolCpFilterValue || patrolRouteCPList?.length) {
        <div class="input-group my-2">
          <div class="form-floating">
            <input
              class="form-control"
              type="text"
              placeholder="Filter"
              (input)="searchCheckPoints($event)"
              [(ngModel)]="patrolCpFilterValue"
            />
            <label>Filter</label>
          </div>

          @if (patrolCpFilterValue) {
            <span
              class="input-group-text"
              (click)="searchCheckPoints({ target: { value: '' } })"
            >
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div>
      }
    }
    @if (patrolRouteCPList?.length) {
      @if (!patrolCPCursor && patrolRouteCPList?.length > 1) {
        <div class="text-end my-2">
          <button
            (click)="addAllCheckpoints()"
            class="btn btn-warning btn-sm"
            type="button"
            [disabled]="patrolJobType?.checkpoints?.data?.length >= 250"
          >
            Add All:
            <span class="fs-6 fw-semibold px-2">{{
              patrolRouteCPList?.length
            }}</span>
          </button>
        </div>
      }
      <div
        class="mb-2"
        [ngClass]="
          patrolRouteCpTotalCount > 10
            ? 'checkpoints-list-with-search'
            : 'checkpoints-list-without-search'
        "
      >
        @for (checkpoint of patrolRouteCPList; track $index) {
          <div class="d-flex align-items-center p-1 p-lg-2 mb-2 gap-2">
            <div
              class="flex-grow-1"
              [class.added-checkpoint]="checkpoint?.id == lastAddedCheckpointID"
            >
              <div class="fw-semibold">
                {{ checkpoint?.name }}
              </div>

              <div class="small-font fw-semibold">
                @if (checkpoint?.site_name) {
                  {{ checkpoint?.site_name }} [{{
                    checkpoint?.company || checkpoint?.company_name
                  }}]
                } @else {
                  {{ checkpoint?.company || checkpoint?.company_name }}
                }
              </div>

              <div class="small-font text-secondary">
                {{
                  checkpoint?.address?.full_address || checkpoint?.full_address
                }}
              </div>
            </div>
            @if (checkpoint?.qr_code) {
              <div>
                @if (checkpoint?.is_nfc_code) {
                  <img
                    src="assets/images/NFC_logo.avif"
                    alt="NFC Code"
                    width="26"
                    class="mb-0 bg-white p-1 rounded"
                  />
                } @else {
                  <img
                    src="assets/images/qr-code-logo.avif"
                    alt="QR Code"
                    width="26"
                    class="mb-0 bg-white p-1 rounded"
                  />
                }
              </div>
            }

            <div>
              <button
                (click)="addSelectedCP(checkpoint)"
                type="button"
                class="btn btn-primary btn-sm m-0"
                [disabled]="patrolJobType?.checkpoints?.data?.length >= 250"
              >
                Add
              </button>
            </div>
          </div>
        }
      </div>
      @if (patrolCPCursor) {
        <div class="text-center my-2">
          <button
            (click)="onLoadMore()"
            class="btn btn-secondary btn-md px-4"
            type="button"
          >
            Load More
          </button>
        </div>
      }
    } @else if (patrolCpFilterValue || cpSiteFilter?.id) {
      <div class="alert alert-primary">
        No Records Match Your Search Criteria
      </div>
    }
  } @else {
    @if (patrolJobType?.checkpoints?.data?.length) {
      <div
        class="d-flex justify-content-between m-1 p-1 ps-2 border rounded align-items-center"
      >
        <div class="fs-5">
          <span class="text-secondary"> Checkpoints:</span>
          <span class="fw-semibold">
            {{ patrolJobType?.checkpoints?.data?.length }}</span
          >
        </div>
        <div>
          @if (patrolJobType?.checkpoints?.data?.length > 1) {
            <button
              (click)="removeAllCheckpoints()"
              class="btn btn-danger btn-sm"
              type="button"
            >
              Remove All
            </button>
          }
        </div>
      </div>
    }
    <div class="checkpoints-list-without-search">
      <div cdkDropList (cdkDropListDropped)="dropCheckPoint($event)">
        @for (
          checkpoint of patrolJobType?.checkpoints?.data;
          track $index;
          let isLastItem = $last
        ) {
          <div class="d-flex align-items-center p-1 p-lg-2 mb-2 gap-2" cdkDrag>
            @if (patrolJobType?.checkpoints?.data?.length > 1) {
              <div cdkDragHandle>
                <i class="fas fa-bars fa-2x"></i>
              </div>
            }

            <div
              class="flex-grow-1"
              [class.added-checkpoint]="
                isLastItem && checkpoint?.id == lastAddedCheckpointID
              "
            >
              <div class="fw-semibold">
                {{ checkpoint?.name }}
              </div>

              <div class="small-font fw-semibold">
                @if (checkpoint?.site_name) {
                  {{ checkpoint?.site_name }} [{{
                    checkpoint?.company || checkpoint?.company_name
                  }}]
                } @else {
                  {{ checkpoint?.company || checkpoint?.company_name }}
                }
              </div>

              <div class="small-font text-secondary">
                {{
                  checkpoint?.address?.full_address || checkpoint?.full_address
                }}
              </div>
            </div>
            @if (checkpoint?.qr_code) {
              <div class="me-2">
                @if (checkpoint?.is_nfc_code) {
                  <img
                    src="assets/images/NFC_logo.avif"
                    alt="NFC Code"
                    width="26"
                    class="mb-0 bg-white p-1 rounded"
                  />
                } @else {
                  <img
                    src="assets/images/qr-code-logo.avif"
                    alt="QR Code"
                    width="26"
                    class="mb-0 bg-white p-1 rounded"
                  />
                }
              </div>
            }
            <div>
              <button
                class="btn btn-danger btn-sm m-0"
                type="button"
                (click)="removeSelectedCP($index)"
              >
                Del
              </button>
            </div>
          </div>
        }
      </div>
      <div id="lastElementAnchor">
        <!--scroll to here/bottom anchor on adding checkpoints-->
      </div>
    </div>
  }
</ng-template>
